import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import register from '@/components/register'
import joinUs from '@/components/joinUs'
import profile from '@/components/profile'
import cooperation from '@/components/cooperation'
import login from '@/components/login'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/join',
      name: 'join',
      component: joinUs
    },
    {
      path: '/profile',
      name: 'profile',
      component: profile
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    { path: '/', redirect: '/index' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js